import type { VirtualItem, Virtualizer } from "@tanstack/react-virtual";
import type { ViewBlock } from "@/lib/chat-render";

/**
 * 先頭へ古い履歴が足されても変わらない、ブロックの目印。
 * ツールグループの key は先頭のツールなので、前に足された古いツールと結合すると変わる。末尾のツールは変わらない。
 */
export function stableBlockId(block: ViewBlock): string {
	return (block.kind === "tool_group" && block.tools.at(-1)?.key) || block.key;
}

type ResizeVirtualizer = Pick<
	Virtualizer<HTMLDivElement, Element>,
	"options" | "itemSizeCache" | "scrollDirection"
>;

/** index より後ろのブロックが、まだ一度も計測されていないか。 */
function isInUnmeasuredTail(virtualizer: ResizeVirtualizer, index: number): boolean {
	const { count, getItemKey } = virtualizer.options;
	for (let i = count - 1; i > index; i--) {
		if (virtualizer.itemSizeCache.has(getItemKey(i))) return false;
	}
	return true;
}

/**
 * ブロックの高さが変わったとき、画面の内容が動かないよう scrollTop を同じだけずらすか。
 * 画面より上のブロックだけをずらす (virtual-core の既定と同じ)。ただし末尾に足されたばかりの
 * 未計測のブロックはずらさない。生成中の表示が確定した応答に置き換わっただけで、
 * 仮の高さとの差でずらすと読んでいた位置から飛ぶため。
 */
export function shouldAdjustScrollOnResize(
	item: VirtualItem,
	virtualizer: ResizeVirtualizer,
	scrollTop: number,
): boolean {
	if (!virtualizer.itemSizeCache.has(item.key)) {
		return item.start < scrollTop && !isInUnmeasuredTail(virtualizer, item.index);
	}
	return item.end <= scrollTop && virtualizer.scrollDirection !== "backward";
}
